import withHtmlSafe from '../withHtmlSafe';
import Subtitle from './Subtitle';
export default withHtmlSafe(Subtitle);